import React, { useEffect, useState } from "react";
import styles from "../PreviewV3.module.css";
import { getProcedureList } from "../../../JobShiftEmergencyProcedures/JobShiftEmergencyProceduresDocument";
import { getEnabledProcedureSections } from "../../../JobShiftEmergencyProcedures/sections/ProcedureDynamicSections";

const getProcedureKey = (procedure, index) => `${procedure && (procedure.id || procedure.procedure_id || procedure.document_number || index)}`;
const getAnchor = (procedureKey, suffix) => `emergency-procedure-${procedureKey}-${suffix}`;
const getSectionLabel = (section) => section.display_name || section.title || section.type || section.id;

export default function EmergencyProceduresPreviewNav({ procedures }) {
  const procedureList = getProcedureList(procedures);
  const firstTarget = procedureList.length ? getAnchor(getProcedureKey(procedureList[0], 0), "details") : "";
  const [activeTarget, setActiveTarget] = useState(firstTarget);

  useEffect(() => setActiveTarget(firstTarget), [firstTarget]);

  const navigate = (event, targetId) => {
    event.preventDefault();
    setActiveTarget(targetId);
    const target = document.getElementById(targetId);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <aside className={styles.PreviewNav}>
      <div className={styles.PreviewNavCard}>
        <div className={styles.PreviewNavHead}><h3>Document Sections</h3></div>
        <div id="emergency-procedures-prv-nav-list">
          {procedureList.map((procedure, procedureIndex) => {
            const procedureKey = getProcedureKey(procedure, procedureIndex);
            const items = [
              { label: "Procedure Details", targetId: getAnchor(procedureKey, "details") },
              { label: "Document Authorization", targetId: getAnchor(procedureKey, "authorization") },
              ...getEnabledProcedureSections(procedure).map((section) => ({
                label: getSectionLabel(section),
                targetId: getAnchor(procedureKey, section.id)
              }))
            ];

            return (
              <React.Fragment key={procedureKey}>
                {procedure.document_number ? (
                  <div className={styles.PreviewNavDocumentNumber}>{procedure.document_number}</div>
                ) : null}
                <div className={styles.PreviewNavList}>
                  {items.map((item, itemIndex) => (
                    <a
                      key={`${procedureKey}-${item.targetId}`}
                      className={`${styles.PreviewNavItem} ${activeTarget === item.targetId ? styles.PreviewNavActiveItem : ""}`}
                      data-target={item.targetId}
                      onClick={(event) => navigate(event, item.targetId)}
                    >
                      <span className={styles.PreviewNavNum}>{itemIndex + 1}</span> {item.label}
                    </a>
                  ))}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </aside>
  );
}
